import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import Checkbox from "./elements/Checkbox"
import Icon from "./elements/Icon"
import SelectedFiltersInFacet from "./elements/SelectedFiltersInFacet"
import { useProductFilters } from "@nosto/preact"
import { useEffect, useRef, useState } from "preact/hooks"
import { isMobile } from "../helpers"

export default function Facet({ facet }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet);

    const [filtersOfFacet, setFiltersOfFacet] = useState([]);

    const { filters, removeAll } = useProductFilters();
    // console.log(facet);
    // console.log(filters);
    const isSizeFacet = facet?.field === "skus.customFields.size";
    
    useEffect(()=>{
        // Update the filtersOfFacet state whenever the filters change
        const updatedFilters = filters.filter(filter => filter.field === facet.field);
        setFiltersOfFacet(updatedFilters);
    }, [filters]);

    const facetRef = useRef(null);
    useEffect(() => {
        if(window.innerWidth > 719){
            const handleClickOutside = (event) => {
              if (facetRef.current && !facetRef.current.contains(event.target)) {
                if (active) {
                  toggleActive();
                }
              }
            };
        
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
              document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, [active, toggleActive]);

    function removeAllFiltersOfFacet() {
        if(!filtersOfFacet.length) return;
        filtersOfFacet.forEach(filter => {
            toggleProductFilter(filter.field, filter.value, false);
        });
    }

    return (
        <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`} aria-expanded={!!active} ref={facetRef}>
            <span
                class="ns-anchor ns-d-inline-block ns-relative ns-w-100 ns-border-box"
                data-nosto-element="facet"
                onClick={toggleActive}
                aria-controls={`${facet.id}-sub-menu`}
                aria-label={`${active ? 'Collapse' : 'Expand' } ${facet.name}`}
            >
                <span class="ns-color-black ns-font-4">{facet.name}</span>
                {selectedFiltersCount > 0 && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center">
                        {selectedFiltersCount}
                    </span>
                )}
                {/* <Icon name="arrow" className="ns-absolute" /> */}
                {isMobile ? (
                    <span class="icon icon-new icon-chevron ">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.875 7.438 12 17.563 22.125 7.438" stroke="currentColor" stroke-width="2"></path></svg>
                    </span>
                    ) : (
                        <span class="icon icon-new icon-chevron-small ">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.875 7.438 12 17.563 22.125 7.438" stroke="currentColor" stroke-width="2.75"></path></svg>
                        </span>
                    )}
                <SelectedFiltersInFacet filtersOfFacet={filtersOfFacet} facetName={facet?.name} removeFilters={removeAllFiltersOfFacet} layout={"mobile"}/>
            </span>
            <div class="ns-sidebar-submenu ns-d-none ns-absolute ns-background-white" id={`${facet.id}-sub-menu`}>
                <SelectedFiltersInFacet filtersOfFacet={filtersOfFacet} facetName={facet?.name} removeFilters={removeAllFiltersOfFacet} layout={"desktop"} />
                <ul class={`ns-list-unstyled ns-m-0 ${isSizeFacet ? "ns-size-filter-list" : ""}`} role="menu">
                    {facet.data?.map(value => (
                        <li
                            key={value.value}
                            class="ns-d-flex ns-align-items-center ns-font-4"
                            data-nosto-element="facet-setting"
                            role="menuitem"
                        >
                            <Checkbox
                                value={value.value}
                                selected={value.selected}
                                isSizeFacet={isSizeFacet}
                                onChange={e => {
                                    e.preventDefault()
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}
                            />
                            <span class="ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1 fs-body-75">
                                ({value.count})
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        </li>
    )
}
